import makeStyles from '@material-ui/styles/makeStyles';

export const useStyles = makeStyles({
  editor: {
    position: 'absolute',
    bottom: '24px',
    right: '24px',
    zIndex: 3
  },
});
